export default {"src":"/_next/static/media/sensors.4451b5e0.svg","height":32,"width":43,"blurWidth":0,"blurHeight":0};